export const RELAY_UI_KIT_KEY = 'relayUiKitData';
export const DEFAULT_CACHE_TTL_MINUTES = 5;
//# sourceMappingURL=cache.js.map